import { createContext } from 'preact/compat';
export const optionsDefaults = {
    initialQuantity: 1,
    items: [],
    min: 1,
    max: 10,
};
export const PriceInputOptionsCtx = createContext(optionsDefaults);
